// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { PriorAuthorizationFollowUpRequestSearchBase } from './priorAuthorizationFollowUpRequestSearchBase.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PriorAuthorizationFollowUpRequestSearchResponse {
    'requests': Array<PriorAuthorizationFollowUpRequestSearchBase>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PriorAuthorizationFollowUpRequestSearchResponse>> = [
        {
            "name":     "requests",
            "baseName": "requests",
            "type":     "Array<PriorAuthorizationFollowUpRequestSearchBase>"
        },
    ];

    static getAttributeTypeMap() {
        return PriorAuthorizationFollowUpRequestSearchResponse.attributeTypeMap;
    }
}
